import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import NeedsAction from "@/pages/NeedsAction";
import Reports from "@/pages/Reports";
import Team from "@/pages/Team";
import Integrations from "@/pages/Integrations";
import WhatsAppInbox from "@/pages/WhatsAppInbox";
import Proforma from "@/pages/Proforma";
import Quotation from "@/pages/Quotation";
import Enquiry from "@/pages/Enquiry";

const Page = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/" element={<Page><Dashboard /></Page>} />
            <Route path="/pipeline" element={<Page><Pipeline /></Page>} />
            <Route path="/leads" element={<Page><Leads /></Page>} />
            <Route path="/whatsapp" element={<Page><WhatsAppInbox /></Page>} />
            <Route path="/proforma" element={<Page><Proforma /></Page>} />
            <Route path="/quotation" element={<Page><Quotation /></Page>} />
            <Route path="/leads/:id" element={<Page><LeadDetail /></Page>} />
            <Route path="/needs-action" element={<Page><NeedsAction /></Page>} />
            <Route path="/reports" element={<Page><Reports /></Page>} />
            <Route path="/team" element={<Page roles={["owner", "manager"]}><Team /></Page>} />
            <Route path="/integrations" element={<Page roles={["owner", "manager"]}><Integrations /></Page>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
